import headerUrl from '@/assets/svg/header.svg';
import footerUrl from '@/assets/svg/footer.svg';

interface Props {
  skyColor: string;
}

// Perceived brightness (0-255). Picks ink color that contrasts with the sky.
function brightness(hex: string): number {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return 0.299 * r + 0.587 * g + 0.114 * b;
}

export function TextOverlayLayer({ skyColor }: Props) {
  const lightSky = brightness(skyColor) > 140;
  const inkColor = lightSky ? '#0E1252' : '#F4EACB';
  const strokeColor = lightSky ? '#F4EACB' : '#0E1252';
  // 4-way drop-shadow pile creates a ~1px outline around the masked shape.
  const outline = [1, 2].flatMap((d) => [
    `drop-shadow(${d}px 0 0 ${strokeColor})`,
    `drop-shadow(-${d}px 0 0 ${strokeColor})`,
    `drop-shadow(0 ${d}px 0 ${strokeColor})`,
    `drop-shadow(0 -${d}px 0 ${strokeColor})`,
  ]).join(' ');
  return (
    <div
      className="layer"
      style={{
        zIndex: 90,
        pointerEvents: 'none',
      }}
    >
      <div
        role="img"
        aria-label="the weather where I live"
        style={{
          position: 'absolute',
          top: '4vh',
          left: '4vw',
          width: 'clamp(180px, 26vw, 360px)',
          aspectRatio: '924 / 317',
          backgroundColor: inkColor,
          WebkitMaskImage: `url(${headerUrl})`,
          maskImage: `url(${headerUrl})`,
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          filter: outline,
          transition: 'background-color 4s ease-in-out, filter 4s ease-in-out',
        }}
      />
      <div
        role="img"
        aria-label="by Avi age five"
        style={{
          position: 'absolute',
          bottom: '4vh',
          right: '4vw',
          width: 'clamp(110px, 16vw, 220px)',
          aspectRatio: '1103 / 881',
          backgroundColor: inkColor,
          WebkitMaskImage: `url(${footerUrl})`,
          maskImage: `url(${footerUrl})`,
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          filter: outline,
          transition: 'background-color 4s ease-in-out, filter 4s ease-in-out',
        }}
      />
    </div>
  );
}
